
import { useRecoilState } from "recoil";
import { createTeeshotAxiosInstance } from "src/http";
import { recoilStates } from "src/recoil/recoilStates";

export default function useRefetchGroup() {
  const [_, setGroup] = useRecoilState(recoilStates.group);

  const refetchGroup = async () => {
    const groupRes = await createTeeshotAxiosInstance().get("/yearBooking/group");
    if (groupRes.data.success === false) {
      throw new Error("group 조회 실패");
    }
    const groupData = groupRes?.data?.data;
    if (!groupRes?.data?.data?.members?.length) {
      setGroup({ id: false, group_logo_url: "", name: "", members: [] });
    } else {
      setGroup({ ...groupData.group, members: groupData.members });
    }
  };
  return refetchGroup;
}
